import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-column menu-rounded menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold fs-6 menu-mobile",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-wrapper menu-column menu-fit" }
const _hoisted_3 = {
  key: 0,
  class: "menu-item",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-sub": "accordion"
}
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = ["alt", "title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "    ", -1)
const _hoisted_7 = {
  key: 0,
  class: "menu-title menu-title_desktop"
}
const _hoisted_8 = { class: "menu-title menu-title_mobile" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-30px" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["hover-scroll-y pe-4 pe-lg-5 menu-width", {
        'menu-width_full': _ctx.sidebarStateExpand
      }]),
      id: "kt_aside_menu_scroll",
      "data-kt-scroll": "true",
      "data-kt-scroll-height": "auto",
      "data-kt-scroll-dependencies": "#kt_aside_logo",
      "data-kt-scroll-wrappers": "#kt_aside_wordspace",
      "data-kt-scroll-offset": "10px",
      ref: "scrollElRef"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuConfig, (item, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                (menuItem.heading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (menuItem.active)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: menuItem.route
                          }, {
                            default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                              _createElementVNode("a", {
                                href: href,
                                onClick: ($event: any) => ([navigate, _ctx.handleClick()]),
                                class: _normalizeClass(["menu-link py-2 fs-6 px-0", [isActive && 'active', isExactActive && 'active']])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass([
                        `bi bi-${menuItem.icon} fz-22`,
                        isActive ? 'text-primary' : '',
                      ]),
                                  alt: menuItem.heading,
                                  title: menuItem.heading
                                }, null, 10, _hoisted_5),
                                _hoisted_6,
                                (_ctx.sidebarStateExpand)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(menuItem.heading), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(menuItem.heading), 1)
                              ], 10, _hoisted_4)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _hoisted_9
          ], 64))
        }), 128))
      ])
    ], 2)
  ]))
}